import React, { Component } from 'react'
import { string, object } from 'prop-types'
import { connect } from 'react-redux'
import { updateInfobox } from '../../../store/Actions/MapActions'

class MarkerImage extends Component {
  state = {
    markerClass: 'activeMarker',
  }

  handleUpdateInfobox = sign => {
    if (sign) {
      this.props.updateInfobox({
        coordinates: null,
        signs: null,
        sign: sign,
        type: 'regular',
      })
      this.setState({ markerClass: 'activeMarker active' })
    } else {
      this.props.updateInfobox({
        coordinates: null,
        signs: null,
        sign: null,
        type: null,
      })
      this.setState({ markerClass: 'activeMarker' })
    }
  }

  render() {
    return (
      <img
        id={`${this.props.sign.properties.id}MarkerImage`}
        className={this.state.markerClass}
        src={this.props.src}
        alt={this.props.alt}
        onClick={() => this.handleUpdateInfobox(this.props.sign)}
        onMouseOver={() => this.handleUpdateInfobox(this.props.sign)}
        onMouseOut={() => this.handleUpdateInfobox(null)}
      />
    )
  }
}

MarkerImage.propTypes = {
  sign: object.isRequired,
  alt: string,
  src: string.isRequired,
}

const mapDispatchToProps = dispatch => ({
  updateInfobox: value => dispatch(updateInfobox(value)),
})

export default connect(
  null,
  mapDispatchToProps
)(MarkerImage)



// WEBPACK FOOTER //
// ./src/components/Map/Markers/MarkerImage.jsx